export default __webpack_public_path__ + "static/media/BorderKingdomsAquilonianEnd.d84edd74.jpg";